import moment from "moment";
import { useDispatch, useSelector } from "react-redux"
import API from "service/API";
import { setGrowthAnalysis } from "store/actionReducers/GrowthStore";

const useGrowth = () => {
  const dispatch = useDispatch();

  const fetchDataGrowth = async (params: any) => {
    if (params?.ticker) {
      const res = await API.Growth.getGrowthChart(params)
      if (res?.code === '0') {
        dispatch(setGrowthAnalysis(res?.data))
      }
    }
  }

  const filterDataGrowth = (data: any, filter: any) => {
    let listData: any = {
      category: [],
      net_profit: [],
      netsale: [],
      gross_profit: [],
      net_sale_growth: [],
    }
    if (data && data.length) {
      data.map((item: any) => {
        const year = moment(item?.yearReport, 'YYYY').format('YY')
        let categoryName = filter?.cycle === 'Y' ? item?.yearReport : `Q${item?.lengthReport}/${year}`
        listData.category.push(categoryName)
        listData.netsale.push(item?.netsale)
        listData.net_profit.push(item?.net_profit)
        listData.gross_profit.push(item?.gross_profit)
        listData.net_sale_growth.push(item?.net_sale_growth)
        // listData.push({})
      })
    }
    return listData
  }

  return { fetchDataGrowth, filterDataGrowth }
}

export default useGrowth